import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconModule = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M1.817 4.524l9.1-3.568a2.936 2.936 0 012.162 0l9.1 3.568a1.763 1.763 0 011.071 1.662v11.628a1.763 1.763 0 01-1.067 1.662l-9.1 3.569a2.956 2.956 0 01-2.162 0l-9.1-3.569A1.763 1.763 0 01.75 17.814V6.186a1.763 1.763 0 011.067-1.662z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 9.353L1.104 5.081M12 9.353l10.896-4.272M12 23.25V9.353",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconModule.displayName = "IconModule";

export { IconModule };
